import { createContext } from 'react';

const SheetContext = createContext({});

export { SheetContext as default };
//# sourceMappingURL=SheetContext.js.map
